import React from 'react';
import './RefundNotification.css';

const RefundNotification = ({ refund, onClose }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Pending':
        return '#ffc107';
      case 'Processing':
        return '#17a2b8';
      case 'Completed':
        return '#28a745';
      case 'Failed':
        return '#dc3545';
      default:
        return '#6c757d';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'Pending':
        return '⏳';
      case 'Processing':
        return '🔄';
      case 'Completed':
        return '✅';
      case 'Failed':
        return '❌';
      default:
        return '📋';
    }
  };

  return (
    <div className="refund-notification-overlay">
      <div className="refund-notification-modal">
        <div className="notification-header">
          <h2>Refund Status Update</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <div className="notification-content">
          <div className="status-section">
            <div className="status-badge" style={{ backgroundColor: getStatusColor(refund.refundStatus) }}>
              <span className="status-icon">{getStatusIcon(refund.refundStatus)}</span>
              <span className="status-text">{refund.refundStatus}</span>
            </div>
          </div>

          <div className="order-details">
            <h3>Order Details</h3>
            <p><strong>Order ID:</strong> #{refund.order?._id?.slice(-8) || 'N/A'}</p>
            <p><strong>Refund Amount:</strong> ₹{refund.refundAmount.toFixed(2)}</p>
            <p><strong>Requested On:</strong> {new Date(refund.createdAt).toLocaleDateString('en-IN')}</p>
          </div>

          <div className="bank-details">
            <h3>Bank Details</h3>
            <p><strong>Account Holder:</strong> {refund.bankDetails.accountHolderName}</p>
            <p><strong>Account Number:</strong> {refund.bankDetails.accountNumber}</p>
            <p><strong>IFSC Code:</strong> {refund.bankDetails.ifscCode}</p>
          </div>

          {refund.adminNotes && (
            <div className="admin-notes">
              <h3>Admin Notes</h3>
              <div className="notes-content">
                {refund.transactionId ? (
                  <>
                    <strong>Transaction ID is: {refund.transactionId}</strong><br/>
                    {refund.adminNotes}
                  </>
                ) : (
                  refund.adminNotes
                )}
              </div>
            </div>
          )}

          {refund.processedAt && (
            <div className="processed-info">
              <p><strong>Processed On:</strong> {new Date(refund.processedAt).toLocaleDateString('en-IN')}</p>
            </div>
          )}

          {refund.utrNumber && refund.refundStatus === 'Completed' && (
            <div className="utr-info">
              <h3>UTR Number</h3>
              <div className="utr-content">
                <strong>{refund.utrNumber}</strong>
              </div>
            </div>
          )}
        </div>

        <div className="notification-actions">
          <button className="close-notification-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default RefundNotification; 